import { UserDocument } from "../models/UserDocument";
import { callGet, CancelToken } from ".";
import { DocumentsAPI } from "./DocumentsAPI";

const cancelTokenSource = CancelToken.source();

type CacheDoc = {
  id: number;
  version?: number;
  thumbnail?: boolean;
  url?: string;
};
let docContentCache: CacheDoc[] = [];

const addToCache = (doc: CacheDoc) => {
  if (!getFromCache(doc)) {
    docContentCache.push(doc);
  }
};

const getFromCache = ({
  id,
  version,
  thumbnail,
}: CacheDoc): CacheDoc | undefined => {
  return docContentCache.find((item: CacheDoc) => {
    return (
      item.id === id && item.version === version && item.thumbnail === thumbnail
    );
  });
};

export const clearCache = (id?: number): void => {
  if (id) {
    docContentCache = docContentCache.filter(
      (item: CacheDoc) => item.id !== id
    );
  } else {
    docContentCache.length = 0;
  }
};

export const getDocumentContents = async (
  estateId: number,
  userId: number,
  id: number,
  version?: number,
  onFinished?: (src: string | null) => void,
  thumbnail = false,
  delayMS = 0,
  allowCache = true,
): Promise<string | undefined> => {
  if (allowCache) {
    const cachedDoc = getFromCache({ id, version, thumbnail });
    if (cachedDoc) {
      return cachedDoc.url;
    }
  }

  // Useful for adding jitter to api requests so we don't overload the server
  if (delayMS) {
    await new Promise(f => setTimeout(f, delayMS));
  }

  const response = await DocumentsAPI.getDocumentContents(estateId, userId, id, version, thumbnail, cancelTokenSource);
  if (response?.data) {
    const file = new Blob([response.data], {
      type: response?.headers["content-type"], // type: "application/pdf"
    });
    const urlCreator = window.URL || window.webkitURL;
    const docUrl = urlCreator.createObjectURL(file);
    addToCache({ id, version, thumbnail, url: docUrl });
    const src = urlCreator.createObjectURL(file);

    if (onFinished) {
      onFinished(src);
    }

    return src;
  } else {
    if (onFinished) {
      onFinished(null);
    }
  }
};